'use client';

import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import GeminiVoiceWidget from '@components/features/voice/GeminiVoiceWidget';
import { fetchMyBestieVoiceSession } from '@services/voice/voiceSessionApi';

export const MyBestieVoiceModal = NiceModal.create(() => {
  const modal = useModal();
  const { t } = useTranslation('common');
  const firstMessage = t('inbound.greeting.mybestie');

  const closeModal = useCallback(() => {
    void modal.hide();
    modal.remove();
  }, [modal]);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="sm"
      className="!max-w-sm !rounded-3xl"
      body={
        <GeminiVoiceWidget
          firstMessage={firstMessage}
          fetchSession={fetchMyBestieVoiceSession}
          onClose={closeModal}
        />
      }
    />
  );
});
